/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Welcome_SubtitleInputs */



/**
* | output |
* | --- |
* | "Your AI-powered workspace for smarter decisions and faster results." |
*
* @param {Home_Welcome_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_welcome_subtitle = /** @type {((inputs?: Home_Welcome_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Welcome_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein KI-gestützter Arbeitsbereich für bessere Entscheidungen und schnellere Ergebnisse.")
	return /** @type {LocalizedString} */ ("Your AI-powered workspace for smarter decisions and faster results.")
});